import { render } from "./GastronomyHero.vue?vue&type=template&id=55d63e1a&scoped=true"
import script from "./GastronomyHero.vue?vue&type=script&lang=js"
export * from "./GastronomyHero.vue?vue&type=script&lang=js"

import "./GastronomyHero.vue?vue&type=style&index=0&id=55d63e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d63e1a"]])

export default __exports__